<template>
  <button @click="onLogin" class="google-btn">
    <svg width="18" height="18" viewBox="0 0 48 48">
      <path fill="#EA4335" d="M24 9.5c3.54 0 6.7 1.22 9.2 3.6l6.9-6.9C35.7 2.3 30.2 0 24 0 14.6 0 6.4 5.6 2.5 13.7l8.1 6.3C12.7 13.3 17.9 9.5 24 9.5z"/>
      <path fill="#4285F4" d="M46.1 24.5c0-1.6-.1-3.2-.4-4.7H24v9h12.5c-.5 2.7-2 5-4.2 6.6l6.6 5.1c3.9-3.6 6.2-9 6.2-16z"/>
      <path fill="#FBBC05" d="M10.6 28.1c-.5-1.5-.8-3-.8-4.6s.3-3.2.8-4.6l-8.1-6.3C.9 16.5 0 20.1 0 24s.9 7.5 2.5 10.7l8.1-6.6z"/>
      <path fill="#34A853" d="M24 48c6.5 0 12-2.1 16-5.8l-6.6-5.1c-2.3 1.5-5.3 2.4-9.4 2.4-6.1 0-11.3-3.8-13.4-9.1l-8.1 6.3C6.4 42.4 14.6 48 24 48z"/>
    </svg>
    Google Login
  </button>
</template>

<script setup>
const emit = defineEmits(['login']);

const onLogin = () => {
  emit('login');
}
</script>

<style scoped>
.google-btn {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;

  width: 100%;
  padding: 10px 16px;

  border: 1px solid #dadce0;
  border-radius: 6px;

  background: white;
  color: #3c4043;

  font-weight: 500;
  text-decoration: none;

  transition: background 0.2s;
}

.google-btn:hover {
  background: #f7f8f8;
}

.icon {
  width: 18px;
  height: 18px;
}
</style>